<template>
  <q-dialog
    v-model="showPopup"
    persistent
    transition-show="scale"
    transition-hide="scale"
  >
    <q-card class="storage-popup">
      <q-card-section>
        <div class="text-h6">Draft schemes</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div
          v-for="scheme in draftSchemes"
          :key="scheme.key"
          class="row items-center justify-between q-mb-sm"
        >
          <p tabindex="0" class="scheme-name">
            {{ scheme.name }}
          </p>
          <div class="q-gutter-sm">
            <q-btn
              icon="las la-2x la-pen"
              size="sm"
              color="primary"
              @click="emitSchemeKey(scheme.key)"
              aria-label="Load scheme"
            />
            <q-btn          
              icon="las la-2x la-trash"
              size="sm"
              color="negative"
              aria-label="Delete scheme"
              @click="deleteScheme(scheme.key)"
            />
          </div>
        </div>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn
          class="orange-btn-filled close-btn"
          v-close-popup          
          label="Close"          
          aria-label="Close popup"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
<script setup>
import { onMounted, ref, defineEmits } from "vue";
import { DRAFT_SCHEME } from "../../constants";

const showPopup = ref(false);
const draftSchemes = ref([]);

const emit = defineEmits(["load-scheme"]);

const loadDraftSchemes = () => {
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key.startsWith(DRAFT_SCHEME)) {
      const timestamp = key.replace(DRAFT_SCHEME, "");
      const value = localStorage.getItem(key);
      try {
        const parsedScheme = JSON.parse(value);
        draftSchemes.value.push({
          key,
          name: parsedScheme.newName || key,
          timestamp
        });
      } catch {
        draftSchemes.value.push({
          key,
          name: key,
          timestamp
        });
      }
    }
  }
  draftSchemes.value.sort((a, b) => a.timestamp.localeCompare(b.timestamp));
};

const deleteScheme = key => {
  localStorage.removeItem(key);
  draftSchemes.value = draftSchemes.value.filter(s => s.key !== key);
};

const emitSchemeKey = key => {
  emit("load-scheme", key);
  showPopup.value = false;
};

onMounted(() => {
  loadDraftSchemes();

  if (draftSchemes.value.length > 0) {
    showPopup.value = true;
  }
});
</script>
